import TRANSLATIONS_DE from "./locales/de.json";
import TRANSLATIONS_EN from "./locales/en.json";
import TRANSLATIONS_ES from "./locales/es.json";
import TRANSLATIONS_FR from "./locales/fr.json";
import TRANSLATIONS_NL from "./locales/nl.json";
import TRANSLATIONS_PT from "./locales/pt.json";
import TRANSLATIONS_TR from "./locales/tr.json";
import TRANSLATIONS_IT from "./locales/it.json";
import TRANSLATIONS_AU from "./locales/au.json";
import TRANSLATIONS_SG from "./locales/sg.json";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { StoreOverride } from "./types/StoreMap";
import { resolveStoreTranslations } from "./utils/translationResolver";

// Base translation resources
export const BASE_RESOURCES = {
  en: TRANSLATIONS_EN,
  es: TRANSLATIONS_ES,
  de: TRANSLATIONS_DE,
  fr: TRANSLATIONS_FR,
  nl: TRANSLATIONS_NL,
  pt: TRANSLATIONS_PT,
  tr: TRANSLATIONS_TR,
  it: TRANSLATIONS_IT,
  au: TRANSLATIONS_AU,
  sg: TRANSLATIONS_SG,
};

/**
 * Updates i18n resources with store-specific translation overrides
 * @param storeOverride - Store-specific configuration containing translation overrides
 */
export function updateI18nWithStoreOverrides(storeOverride: StoreOverride | undefined) {
  const resources: any = {};

  // Process each language
  for (const language of Object.keys(BASE_RESOURCES)) {
    const baseTranslations = BASE_RESOURCES[language as keyof typeof BASE_RESOURCES];
    const resolvedTranslations = resolveStoreTranslations(baseTranslations, storeOverride, language);

    resources[language] = {
      translation: resolvedTranslations,
    };
  }

  // Update i18n resources
  for (const language of Object.keys(resources)) {
    i18n.addResourceBundle(language, 'translation', resources[language].translation, true, true);
  }
}

i18n.use(initReactI18next).init({
  fallbackLng: "en",
  interpolation: {
    escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
  },
  debug: true,
  resources: {
    en: {
      translation: TRANSLATIONS_EN,
    },
    es: {
      translation: TRANSLATIONS_ES,
    },
    de: {
      translation: TRANSLATIONS_DE,
    },
    fr: {
      translation: TRANSLATIONS_FR,
    },
    nl: {
      translation: TRANSLATIONS_NL,
    },
    pt: {
      translation: TRANSLATIONS_PT,
    },
    tr: {
      translation: TRANSLATIONS_TR,
    },
    it: {
      translation: TRANSLATIONS_IT,
    },
    au: {
      translation: TRANSLATIONS_AU,
    },
    sg: {
      translation: TRANSLATIONS_SG,
    },
  },
});

export default i18n;
